import React, { useEffect , useRef} from 'react';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { VRMLoaderPlugin, VRMUtils } from '@pixiv/three-vrm';
import { VRMLookAtQuaternionProxy, createVRMAnimationClip,VRMAnimationLoaderPlugin } from '@pixiv/three-vrm-animation';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial';
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry';
import { Line2 } from 'three/examples/jsm/lines/Line2';

function VRMViewer({ rendererRef }) {
    const curveObjectRef = useRef(null); 

    useEffect(() => {
        // Setup the renderer
        const renderer = new THREE.WebGLRenderer({antialias:true});
        renderer.setSize(window.innerWidth, window.innerHeight);
        rendererRef.current.appendChild(renderer.domElement);

        // Setup the camera
        const camera = new THREE.PerspectiveCamera(30.0, window.innerWidth / window.innerHeight, 0.1, 1000.0);
        camera.position.set(0.0, 1.0, -5.0);

        let startPos = false;

        // Setup the camera controls
        const controls = new OrbitControls(camera, renderer.domElement);
        controls.screenSpacePanning = true;
        controls.enablePan = false;
        controls.target.set(0.0, 0.8, 0.0);
        controls.update();

        // Setup the scene
        const scene = new THREE.Scene();

        // Add lighting
        const light = new THREE.DirectionalLight(0xffffff, Math.PI);
        light.position.set(1, 1.0, -0.8).normalize();
        scene.add(light);

        const geometry = new THREE.SphereGeometry(6, 20, 20);
        geometry.scale(-1, 0.3, 1); // Invert the geometry to be visible from inside

        const texture = new THREE.TextureLoader().load('beachpanorama.jpg');
        const material = new THREE.MeshBasicMaterial({ map: texture });

        const sphere = new THREE.Mesh(geometry, material);
        sphere.position.y = 1.7;
        scene.add(sphere);

        // Setup the GLTF loader with VRM plugins
        const loader = new GLTFLoader();
        loader.crossOrigin = 'anonymous';
        loader.register(parser => new VRMLoaderPlugin(parser));
        loader.register(parser => new VRMAnimationLoaderPlugin(parser));

        // Declare mixer in the useEffect scope
        let mixer;
        let vrmInstance;
        // Async function to handle VRM and VRMA loading
        async function loadModels() {
            const gltfVrm = await loader.loadAsync('pinkwhiteshorts2.vrm');
            const vrm = gltfVrm.userData.vrm;
            vrm.lookAt.target = camera;
            //VRMUtils.removeUnnecessaryVertices(vrm.scene);
            //VRMUtils.removeUnnecessaryJoints(vrm.scene);
            vrm.scene.traverse(obj => { obj.frustumCulled = false; });
            //const lookAtQuatProxy = new VRMLookAtQuaternionProxy(vrm.lookAt);
            //vrm.scene.add(lookAtQuatProxy);
            scene.add(vrm.scene);
            console.log(vrm)
     
            /*const gltfVrma = await loader.loadAsync('waiting-4DOXHN5U.vrma'); //'liked-QPZJXMIS.vrma');
            const vrmAnimation = gltfVrma.userData.vrmAnimations[0];
            const clip = createVRMAnimationClip(vrmAnimation, vrm);
            mixer = new THREE.AnimationMixer(vrm.scene);  // Initialize mixer here
            mixer.clipAction(clip).play();*/

            
            //vrmAnimation.humanoidTracks.rotation.get("neck").values.fill(0)
            //vrmAnimation.humanoidTracks.rotation.get("head").values.fill(0)

            vrmInstance = vrm;
            vrmInstance.expressionManager.setValue('Weight', 0);

            loopAnimations(vrm);
            /*const handBone = vrmInstance.humanoid.getRawBoneNode('hips');
            curveObjectRef.current = drawSpline(handBone.position, {x: 0, y: 2, z: 0}, 0xffffff);
            
            scene.add(curveObjectRef.current);*/
        }

        // Function to play an animation and return a promise that resolves when the animation finishes
        function playAnimation(action, mix) {
            action.play();
            return new Promise(resolve => {
                mix.addEventListener('finished', event => {
                    if (event.action === action) {
                        resolve();
                    }
                }, { once: true });
            });
        }
        let mixer2;
        // Main function to load and loop animations
        async function loopAnimations(vrm) {
            try {
                //const actionOne = await loadAnimation('waiting-4DOXHN5U.vrma', vrm);
                //const actionTwo = await loadAnimation('liked-QPZJXMIS.vrma', vrm);

                const gltfVrma = await loader.loadAsync('waiting-4DOXHN5U.vrma'); //'liked-QPZJXMIS.vrma');
                const vrmAnimation = gltfVrma.userData.vrmAnimations[0];
                const clip = createVRMAnimationClip(vrmAnimation, vrm);


                mixer = new THREE.AnimationMixer(vrm.scene);  // Initialize mixer here
                const actionOne = mixer.clipAction(clip)
                actionOne.setLoop(THREE.LoopOnce);
                actionOne.clampWhenFinished = true;
                actionOne.time = 10;
                //actionOne.stop().play();

                //console.log("HEREE")

                const gltfVrma2 = await loader.loadAsync('liked-QPZJXMIS.vrma'); //'liked-QPZJXMIS.vrma');
                const vrmAnimation2 = gltfVrma2.userData.vrmAnimations[0];
                const clip2 = createVRMAnimationClip(vrmAnimation2, vrm);
                //mixer2 = new THREE.AnimationMixer(vrm.scene);  // Initialize mixer here
                const actionTwo = mixer.clipAction(clip2)
                actionTwo.setLoop(THREE.LoopOnce);
                actionTwo.clampWhenFinished = true;
                //actionTwo.reset().play();

                // Function to handle the end of an animation
                function onFinished(event) {
                    if (event.action === actionOne) {
                        actionOne.crossFadeTo (actionTwo,1);
                        actionTwo.reset().play();
                    } else if (event.action === actionTwo) {
                        actionTwo.crossFadeTo (actionOne,1);
                        actionOne.reset().play();  
                    }
                }

                // Add listeners to detect when each animation finishes
                mixer.addEventListener('finished', onFinished);
                //mixer2.addEventListener('finished', onFinished);

                // Start the first animation
                actionOne.reset().play();
                
                //console.log("BEGIN LOOP")
                //while (true) { // Loop indefinitely
                    //await playAnimation(actionTwo, mixer2);
                    //await playAnimation(actionOne, mixer);
                    
                //}
            } catch (error) {
                console.error('Failed to load or play animations:', error);
            }
        }


        let enableTube = false;
        const toggleTube = (toggle) =>{
            enableTube = toggle;
            if (toggle){
                const handBone = vrmInstance.humanoid.getRawBoneNode('hips');
                curveObjectRef.current = drawSpline(handBone.position, {x: 0, y: 2, z: 0}, 0xffffff);
                
                scene.add(curveObjectRef.current);
            }else if (curveObjectRef.current){
                scene.remove(curveObjectRef.current);
            }
        }

        const toggleSkirt = (toggle) => {
            vrmInstance.scene.children[2].visible = toggle;//!vrmInstance.scene.children[2].visible;
        }
        let prog = 0;

        const deflate = (amount) => {
            console.log(prog,amount);
            prog -= amount;
            setWeight(prog);
        }

        const setWeight = (weight) => {
            vrmInstance.expressionManager.setValue('Weight', weight);
        }

        const setChest = (chest) => {
            vrmInstance.expressionManager.setValue('Chest', chest);
        }

        rendererRef.current.toggleTube = toggleTube;
        rendererRef.current.toggleSkirt = toggleSkirt;
        rendererRef.current.deflate = deflate;
        rendererRef.current.setWeight = setWeight;
        rendererRef.current.setChest = setChest;

        function createWideLine(points, color, lineWidth) {
            const lineGeometry = new LineGeometry();
            const positions = [];
            points.forEach(p => {
                positions.push(p.x, p.y, p.z);
            });
            lineGeometry.setPositions(positions);
        
            const lineMaterial = new LineMaterial({
                color: color,
                linewidth: lineWidth, // This is in pixels
                resolution: new THREE.Vector2(window.innerWidth, window.innerHeight) // Needed for correct linewidth
            });
        
            const line = new Line2(lineGeometry, lineMaterial);
            line.computeLineDistances();
        
            return line;
        }

        function createTubeLine(points, tubeRadius, radialSegments, color) {
            const curve = new THREE.CatmullRomCurve3(points);
            const tubeGeometry = new THREE.TubeGeometry(curve, 64, tubeRadius, radialSegments, false);
            const tubeMaterial = new THREE.MeshBasicMaterial({ 
                color: color,
                opacity: 0.5,      // Set opacity to 0.5
                transparent: true  // Enable transparency
            });
            const tube = new THREE.Mesh(tubeGeometry, tubeMaterial);
            return tube;
        }
        

        function drawSpline(beginning, end, clr, shiftRatio = 1, numControlPoints = 5) {
            // Calculate the total distance
            const dx = end.x - beginning.x;
            const dy = end.y - beginning.y;
            const dz = end.z - beginning.z;
        
            // Define control points array and add starting point
            let controlPoints = [new THREE.Vector3(beginning.x, beginning.y, beginning.z)];
        
            const directionVector = new THREE.Vector3(dx, dy, dz).normalize();
            // Standard perpendicular vector in the YZ-plane
            const basePerpVector = new THREE.Vector3(0, -dz, dy).normalize();
        
            for (let i = 1; i <= numControlPoints; i++) {
                // Calculate t for interpolating points
                let t = i / (numControlPoints + 1);
                let posX = beginning.x + t * dx;
                let posY = beginning.y + t * dy;
                let posZ = beginning.z + t * dz;
        
                // Rotate the base perpendicular vector slightly by each control point
                let angle = Math.PI * t; // Change this factor to control the twist
                let cosAngle = Math.cos(angle);
                let sinAngle = Math.sin(angle);
                let perpVector = new THREE.Vector3(
                    basePerpVector.x * cosAngle + basePerpVector.z * sinAngle,
                    basePerpVector.y,
                    -basePerpVector.x * sinAngle + basePerpVector.z * cosAngle
                );
        
                // Determine displacement magnitude
                let displacementMagnitude = Math.sin(t * Math.PI) * shiftRatio * (Math.abs(beginning.y - end.y) + 0.7);
        
                // Apply displacement
                let displacement = perpVector.multiplyScalar(displacementMagnitude);
        
                // Add the displaced point to the control points array
                controlPoints.push(new THREE.Vector3(posX + displacement.x, posY + displacement.y, posZ + displacement.z));
            }
        
            // Add the ending point
            controlPoints.push(new THREE.Vector3(end.x, end.y, end.z));
        
            // Create the curve using CatmullRomCurve3
            var curve = new THREE.CatmullRomCurve3(controlPoints);
        
            // Create the curve object
            var points = curve.getPoints(50); // More points for a smoother curve
            //var geometry = new THREE.BufferGeometry().setFromPoints(points);
            return createTubeLine(points, 0.008, 6, 'white') ;

            //return curveObject;

            
        }

        window.addEventListener('resize', () => {
            const sizes = {}
            sizes.width = rendererRef.current.clientWidth;
            sizes.height = rendererRef.current.clientHeight;
        
            camera.aspect = sizes.width / sizes.height;
            camera.updateProjectionMatrix();
        
            renderer.setSize(sizes.width, sizes.height);
            //renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
            
            //renderer.render(scene, camera); // -> Also needed
        });

        loadModels();

        
        // Setup animation loop
        const clock = new THREE.Clock();
        function animate() {
            requestAnimationFrame(animate);

            /*
            const canvas = renderer.domElement;
            // look up the size the canvas is being displayed
            const width = canvas.clientWidth;
            const height = canvas.clientHeight;
            //console.log(rendererRef.current.clientWidth, width)
            if (rendererRef.current.clientWidth != width || rendererRef.current.clientHeight != height){
                console.log(rendererRef.current.clientWidth, rendererRef.current.clientHeight, false)
                renderer.setSize(rendererRef.current.clientWidth, rendererRef.current.clientHeight, false);
                camera.aspect = rendererRef.current.clientWidth / rendererRef.current.clientHeight;
                 camera.updateProjectionMatrix();
            }*/

            //renderer.setSize(rendererRef.current.clientWidth, rendererRef.current.clientHeight, false);
            //console.log(rendererRef.current.clientWidth)
            let deltaTime = 0;
            if (mixer) {
                deltaTime = clock.getDelta();
                mixer.update(deltaTime);
                vrmInstance.update( deltaTime );
            }
            rendererRef.current.progress = prog*100;
            if (vrmInstance && curveObjectRef.current && enableTube) {
                prog += deltaTime/25;
                
                vrmInstance.expressionManager.setValue('Belly', prog);
                //if (!startPos)
                    startPos = {...camera.position};
                startPos.y -= 1;
                startPos.x -= 2;
                //console.log(startPos)

                const hipBone = vrmInstance.humanoid.getRawBoneNode('hips');
                //console.log(handBone.position)
                scene.remove(curveObjectRef.current);
                let pos = new THREE.Vector3();
                hipBone.getWorldPosition(pos);

                pos.y -= 0.05;

                const handBone = vrmInstance.humanoid.getRawBoneNode('rightHand');
                let pos2 = new THREE.Vector3();
                handBone.getWorldPosition(pos2);

                //curveObjectRef.current = drawSpline(pos, startPos, 0xffffff);//{x: 0, y: 2, z: 0}
                

                if (camera.position.z > pos.x)
                    curveObjectRef.current = drawSpline(pos, startPos, 0xffffff);//{x: 0, y: 2, z: 0}
                else
                    curveObjectRef.current = drawSpline(startPos,pos, 0xffffff);//{x: 0, y: 2, z: 0}
                
                scene.add(curveObjectRef.current);
            }

            renderer.render(scene, camera);
        }

        animate();

       

        return () => {
            renderer.dispose();
            //camera.dispose();
            controls.dispose();
        };
    }, [rendererRef]);

    return null;
}

export default VRMViewer;


        // Build a spline representing the wire between the roof and the bulb. The new middle point is computed as the middle point shifted orthogonally from the lign by shiftRatio
        function drawSpline3(beginning,end,clr, shiftRatio=0.3){
            // Compute y sign to know which way to bend the wire
            let ySign = Math.sign((end.y+beginning.y)/2)
            // Compute the bending strength and multiply per Math.abs(beginning.y) to ensure it decreases as the bulb gets closer to the theta = 0 position, and also to ensure
            // that the shift is null if thete is null (no discontinuity in the wire movement)
            let appliedRatio = -shiftRatio*Math.abs(beginning.y)
            // Compute middle line position vector and the direction vector from the roof to the bulb
            let midVector = new THREE.Vector3( 0, (end.y+beginning.y)/2, (end.z+beginning.z)/2 )
            let positionVector = new THREE.Vector3(0,end.y-beginning.y,end.z-beginning.z)
            // Compute the orthogonal vector to the direction vector (opposite sense to the bending shift)
            let orthogVector = new THREE.Vector3(0,positionVector.z,-positionVector.y).normalize() 


            // Compute the curve passing by the three points
            var curve = new THREE.CatmullRomCurve3( [
                new THREE.Vector3( beginning.x, beginning.y, beginning.z ),
                midVector.clone().addScaledVector(orthogVector,ySign*appliedRatio),
                new THREE.Vector3( end.x, end.y, end.z ),
            ]);

            // Build the curve line object
            var points = curve.getPoints( 20 );
            var geometry = new THREE.BufferGeometry().setFromPoints( points );
            var material = new THREE.LineBasicMaterial( { color : clr } );

            // Create the final object to add to the scene
            var curveObject = new THREE.Line( geometry, material );
            return curveObject;
        }